<template>
  <div v-if="isCardInfoLoading" class="loader">
    <loading-icon class="--primary" />
  </div>
  <div v-else-if="cardsPayment && cardsPayment.length">
    <details-card-payment v-for="(card, index) of cardsPayment"
                          :card="card"
                          :key="index" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DetailsCardPayment from '@/components/profile/payment/DetailsCardPayment.vue';
import LoadingIcon from '@/utils/components/LoadingIcon.vue';

export default {
  name: 'ListCardsPayment',
  nameClassStyle: 'list-cards-payment',
  components: {
    DetailsCardPayment,
    LoadingIcon,
  },
  computed: {
    ...mapGetters({
      cardsPayment: 'profileStore/cardsPayment',
      isCardInfoLoading: 'profileStore/isCardInfoLoading',
    }),
  },
};
</script>

<style scoped lang="scss">
.--margin-top {
  margin-top: 20px;
}
.list-cards-payment {
  &__button {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
